export const GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES";
export const GET_SUB_CATEGORY_BY_ID = "GET_SUB_CATEGORY_BY_ID";
export const UPDATE_SUB_CATEGORY = "UPDATE_SUB_CATEGORY";
export const DELETE_SUB_CATEGORY = "DELETE_SUB_CATEGORY";
export const CREATE_SUB_CATEGORY = "CREATE_SUB_CATEGORY";
